import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { trackEvent, getUserTypeStatus } from '@surfline/web-common';

import { setNumCams } from 'actions/multiCam';
import { useDeviceSize } from 'hooks/useDeviceSize';
import createAccessibleOnClick, { BTN } from 'utils/createAccessibleOnClick';

import SingleCamIcon from './SingleCamIcon';
import DualCamIcon from './DualCamIcon';
import TripleCamIcon from './TripleCamIcon';
import QuadCamIcon from './QuadCamIcon';
import NintupleCamIcon from './NintupleCamIcon';

const getContainerClass = (active: boolean) =>
  classNames({
    'sl-multi-cam-cam-icon__container': true,
    'sl-multi-cam-cam-icon__container--active': !!active,
  });

interface Props {
  active: boolean;
  camNum: number;
}

const CamIcon = ({ active, camNum }: Props) => {
  const dispatch = useDispatch();
  const device = useDeviceSize();
  const userType = useSelector(getUserTypeStatus);

  const onClick = () => {
    dispatch(setNumCams(camNum));
    trackEvent('Toggled Cam View', {
      category: 'cams & reports',
      name: 'multi-cam - view',
      isMobileView: device.width < 976,
      view: camNum > 1 ? 'MULTI' : 'SINGLE',
      camNumber: camNum,
      subscriptionEntitlement: userType,
    });
  };

  return (
    <button
      type="button"
      disabled={!!active}
      {...createAccessibleOnClick(onClick, BTN)}
      className={getContainerClass(active)}
      aria-label={`Toggle ${camNum} cam view`}
    >
      {camNum === 1 && <SingleCamIcon active={active} />}
      {camNum === 2 && <DualCamIcon active={active} />}
      {camNum === 3 && <TripleCamIcon active={active} />}
      {camNum === 4 && <QuadCamIcon active={active} />}
      {camNum === 9 && <NintupleCamIcon active={active} />}
    </button>
  );
};

export default CamIcon;
